// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"188":"cee4b7e4","236":"39eb4ebf","408":"48890ee7","514":"690cf000","910":"006d4a8e"}[chunkId] + ".chunk.css";
};